import React from 'react';
import { Route } from 'react-router-dom';
import { connectSideNavWithOptionalComponents } from 'shared/hoc/withSideNav';
import WelcomePage from './WelcomePage';
import FavoriteItems from './FavoriteItems';

const optionalComponents = () => <FavoriteItems />;
const withSideNav = connectSideNavWithOptionalComponents({
  optionalComponents,
  title: 'Home',
});

function Home() {
  return <Route path="/" component={WelcomePage} />;
}

const homeModule = {
  RouteComponent: withSideNav(Home),
  module: 'home',
  name: 'Home',
  path: '/',
  rootPath: '/',
};

export default homeModule;
